const t=Symbol(),e=Object.getPrototypeOf,o=new WeakMap,a=a=>(t=>t&&(o.has(t)?o.get(t):e(t)===Object.prototype||e(t)===Array.prototype))(a)&&a[t]||null,r=(t,e=!0)=>{o.set(t,e)};export{a as getUntracked,r as markToTrack};
